module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-impressed.8e4e611c.png";